import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { businessUpdateTxState } from '../actions/business_update_tx_state'
import { saveChangesModalConfirmation, validateModalConfirmation } from '../actions/modal_confirmation'
import { convertTransactionMessage } from '../actions/status_converter'
import { BUSINESS_STATUS_ACCEPTED, BUSINESS_STATUS_REJECTED } from '../config'
import SpinnerCircle from './spinner_circle'

const BusinessConfirmationModal = ({
  isModalConfirmationOpen,
  close,
  title,
  newState,
  isTxChangesSaved,
  isFetching,
  errorMessage,
  responseData,
  cancel,
  validateModalConfirmation,
  isValidated,
  businessUpdateTxState,
  id,
  saveChangesModalConfirmation,
}) => {
  const [notes, setNotes] = useState('')
  const handleSaveChanges = () => {
    if (!notes) {
      validateModalConfirmation(false)
      return
    }
    businessUpdateTxState(id, newState, { notes })
    saveChangesModalConfirmation(newState)
  }

  const handleOnNotesChange = (e) => {
    setNotes(e.target.value)
    if (isValidated) {
      return
    }
    validateModalConfirmation(true)
  }
  let modalText
  if (newState) {
    if (newState === BUSINESS_STATUS_REJECTED) {
      modalText = <span className='bg-danger p-xxs text-uppercase'>{newState}</span>
    } else if (newState === BUSINESS_STATUS_ACCEPTED) {
      modalText = <span className='bg-primary p-xxs text-uppercase'>{newState}</span>
    } else {
      modalText = <span className='bg-success p-xxs text-uppercase'>{newState}</span>
    }
  }

  const onHide = isTxChangesSaved ? close : cancel
  let frontEndResponseData
  if (responseData) {
    frontEndResponseData = convertTransactionMessage(responseData.message)
  }
  return (
    <Modal show={isModalConfirmationOpen} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {responseData && isTxChangesSaved ? (
          <div className='alert alert-success animated fadeIn'>{frontEndResponseData}</div>
        ) : (
          <div>
            <div>You are about to update transaction status to {modalText}</div>
            <label>Enter notes</label>
            <textarea
              rows='4'
              value={notes}
              type='textarea'
              className='form-control'
              required
              onChange={(e) => handleOnNotesChange(e)}
            />
          </div>
        )}
        <div className='m-xs' />
        {!isValidated && <div className='alert alert-danger animated fadeIn'>Notes required</div>}
        {errorMessage && <div className='alert alert-danger animated fadeIn'>{errorMessage}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer>
          {isTxChangesSaved ? (
            <Button onClick={() => close()} variant={'default'}>
              Close
            </Button>
          ) : (
            <Button onClick={() => cancel()} variant={'default'}>
              Cancel
            </Button>
          )}
          {!isTxChangesSaved && (
            <Button variant='primary' onClick={() => handleSaveChanges()}>
              Save changes <SpinnerCircle isActive={isFetching} />
            </Button>
          )}
        </Modal.Footer>
      </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.businessUpdateTxState.errorMessage,
  responseData: state.businessUpdateTxState.responseData,
  isFetching: state.businessUpdateTxState.isFetching,
  isTxChangesSaved: state.modalConfirmation.isTxChangesSaved,
  isValidated: state.modalConfirmation.isValidated,
  newState: state.modalConfirmation.newState,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      businessUpdateTxState,
      saveChangesModalConfirmation,
      validateModalConfirmation,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessConfirmationModal))
